import type { StateCreator } from "zustand";
import { MAX_OUTPUTS_PER_NODE } from "../constants";
import type { NodeOutputEntry } from "../types";
import type { RunControlState } from "./index";

export interface OutputsSlice {
  nodeOutputs: Map<string, NodeOutputEntry[]>;
  lastNodeOutput: NodeOutputEntry | null;
  addNodeOutput: (entry: NodeOutputEntry) => void;
  clearNodeOutputs: (nodeId: string) => void;
  clearAllOutputs: () => void;
}

export const createOutputsSlice: StateCreator<
  RunControlState,
  [["zustand/immer", never], ["zustand/subscribeWithSelector", never]],
  [],
  OutputsSlice
> = (set) => ({
  nodeOutputs: new Map(),
  lastNodeOutput: null,

  addNodeOutput: (entry) =>
    set((state) => {
      const list = state.nodeOutputs.get(entry.nodeId) ?? [];
      if (list.some((item) => item.id === entry.id)) {
        return;
      }
      list.push(entry);
      if (list.length > MAX_OUTPUTS_PER_NODE) {
        list.splice(0, list.length - MAX_OUTPUTS_PER_NODE);
      }
      state.nodeOutputs.set(entry.nodeId, list);
      state.lastNodeOutput = entry;
    }),

  clearNodeOutputs: (nodeId) =>
    set((state) => {
      state.nodeOutputs.delete(nodeId);
      if (state.lastNodeOutput?.nodeId === nodeId) {
        state.lastNodeOutput = null;
      }
    }),

  clearAllOutputs: () =>
    set((state) => {
      state.nodeOutputs = new Map();
      state.lastNodeOutput = null;
    }),
});
